import Vue from 'vue'
import StringHelpers from './StringHelpers'
import FirebaseHelpers from './FirebaseHelpers'

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import Store from '../store/Store'
import DateHelpers from './DateHelpers'
import DataHelpers from './DataHelpers'
import {format} from 'date-fns'
import LookupData from '@/helpers/LookupData'
import NiceData from '../data/NiceData'

export default class {

    static getUserId() {
        if(firebase.auth().currentUser)
            return firebase.auth().currentUser.uid
        else
            return null
    }

    static isInsightUser(user) {
        if(!user)
            user = this.getUser()
        
        const uid = user.uid || user.key || user._key || (user.meta ? user.meta.key : 'no_user_key')

        const processors = LookupData.processors()
        if(!user.email)
            return false
        if(processors.findIndex(o => o.email == user.email) > -1)
            return true
        if(processors.findIndex(o => o.uid == uid) > -1)
            return true
            
        return false
    }

    static isAdministrator() {
        const userEmail = this.getUserEmail()
        
        return userEmail == 'matt.ireland.home@gmail.com' ||
            userEmail == 'shannon.mcleish@insightprocessing.com.au'
    }
    
    static fetchUser (timeToWait = 500, allowGoogleUser) {
        let self = this
        return new Promise(function(resolve, reject) {
            let nextTimeToWait = timeToWait
            if(nextTimeToWait < 5000)
                nextTimeToWait *= 1.3
            let user = Store.getters.user
            
            let str = Store
            
            if(user && user.firstName && (user.office || allowGoogleUser) ) {
                console.log('fetchUser returns', user)
                resolve(user)
            } else {
                str.commit('startLoading','User')
                console.log('fetchUser is waiting...(' + Math.round(timeToWait / 100)/10 + 's)')
                setTimeout(function(){
                    str.commit('stopLoading', 'User')
                    self.fetchUser(nextTimeToWait, allowGoogleUser).then(function(user) {
                        resolve(user)
                    })
                },timeToWait)
            }
        })       
    }

    static getSettings (group) {
        let self = this
        return new Promise(function(resolve, reject) {

            let user = Store.getters.user
            let tenantKey = Store.getters.tenantKey

            if(!user || !user.uid){
                console.log('getSettings > no user')
                return
            }

            let ref = firebase.database().ref('users').child(user.uid).child('offices').child(tenantKey).child('preferences').child(group) 
            console.log('getSettings', ref.toString())
            ref.once('value', function(snap) {
                resolve(snap.val() || {})
            })
        })       
    }

    static loading () {
        return Store.getters.loading
    }

    static getStamp () {
        let user = Store.getters.user
        let stamp = {}
        
        stamp.date = DateHelpers.todayString()
        stamp.time = DateHelpers.timeString()
        stamp.firstName = user.firstName || null
        stamp.lastName = user.lastName || null
        stamp.userKey = user.uid || null
        return stamp
    }

    
    
    static formatStamp (stamp) {
        if(!stamp)
            return ''

        let str = (stamp.firstName || '')

        let datePart = format(DateHelpers.backwardsToDate(stamp.date), 'd/M')
        if(DateHelpers.isToday(stamp.date))
            datePart = 'Today'
        
            
        if(stamp.date)
            str += ' (' + datePart + '@' + stamp.time.replace(/^0+/, '') + ')'

        if(str)
            str = ' - ' + str

        return str
    }
    
    static officeName() {
        return this.officeNameFromKey(Store.getters.tenantKey)
    }

    static officeNameFromKey(key) {
        let office = Store.getters.offices.find(o => o.meta.key == key)
        if(!office)
            return ''
        return office.name
    }

    static preferredOffice() {
        let offices = Store.getters.officesActive
        let defaultTenant = Store.getters.tenantDefault
        
        if(!offices || !defaultTenant) {   
            return '999'
        }

        let office = offices.find(o => o.meta.key == defaultTenant.key)
        if(office)
            return office
        
        return offices[0]
    }

    static getTenantKey() {
        return Store.getters.tenantKey
    }

    static getTenantRef(key) {
        let tenantKey = key || this.getTenantKey()
        if(!tenantKey) {
            console.log('Cant get tennant id')
            
        }
        //console.log('getTenantRef > with key', tenantKey)
        return firebase.database().ref('tenants').child(tenantKey)
    }

    static getOfficesWithRefs() {
        let offices = Store.getters.officesActive
        offices.forEach(office => {
            office.ref = this.getRootRef().child('tenants').child(office.meta.key)
        })
        return offices
    }

    static getTransactionRef(transactionKey, tenantKey) {
        transactionKey = transactionKey || this.getTransactionKey()
        return this.getTenantRef(tenantKey).child('transactions').child(transactionKey)
    }
 
    static getTransactionSummaryRef() {
        return this.getTenantRef().child('transactionSummary')
    }

    static getTransactionKey() {
        return Store.getters.transaction.key
    }

    static getTransactionDetails() {
        return Store.getters.transaction
    }

    static getRootRef() {
        return firebase.database().ref()
    }   
 
    static getUserRef() {
        let uid = this.getUserId()

        return this.getRootRef().child('users').child(uid)
    }   

    static getUser() {
        return Store.getters.user
    }

    static getUserEmail() {
        const user = firebase.auth().currentUser
        if(user)
            return user.email
        else
            return null
    }




    
    static getPreferencesRef (tenantKey, uid) {
        tenantKey = tenantKey || this.getTenantKey()
        uid = uid || this.getUserId()
        return this.getRootRef().child('users').child(uid).child('offices').child(tenantKey).child('preferences')                
    }

    static getPreferencesGroup(tenantKey, uid, group) {
        return new Promise( (resolve, reject) => {
            const ref = this.getPreferencesRef(tenantKey, uid).child(group)
            NiceData.fetchItemSingle(ref).then(group => {
                if(!group)
                    group = {}
                resolve(group)
            })  
        })
    }

    static getRoles () {
        return ['Client', 'Referrer','Solicitor', 'Agent', 'Builder', 'Guarantor', 'Consultant', 'Supplier Contact']
    }

    static activityTypes () {
        return [
            {id: 'c', name: 'Comment'},
            {id: 't', name: 'Task'},
            {id: 'e', name: 'Email'},
            {id: 's', name: 'SMS Message'},
            {id: 'k', name: 'Link'},
            {id: 'd', name: 'Document'},
            {id: 'sw', name: 'Switch'},
            {id: 'sl', name: 'Slider'},
            {id: 'tb', name: 'Textbox'},
            {id: 'dt', name: 'Date'},
            {id: 'li', name: 'List'},
            {id: 'f', name: 'File'},
            {id: 'i', name: 'Information'},
            {id: 'ct', name: 'Contact'},

        ]
    }

    static transactionFlags () {
        return [
            'First Home Owner',
            'Purchase',
            'Refinance',
            'Guarantor',
            'Construction'
        ]
    }

    // static displayTypes () {
    //     return [
    //         'Switch',
    //         'Checkbox',
    //         'Textbox',
    //         'Date',
    //         'List',
    //     ]
    // }

    static suppliers () {
        return [
            'ANZ',
            'CBA',
            'ING Direct',
            'Macquarie',
            'Mortgage Choice',
            'NAB',
            'Suncorp',
            'Westpac',
        ]
    }

    static unionByKey(arr1, arr2) {
        let union = arr1.concat(arr2);
    
        for (let i = 0; i < union.length; i++) {
            for (let j = i+1; j < union.length; j++) {
                if (union[i].key === union[j].key) {
                    union.splice(j, 1);
                    j--;
                }
            }
        }
        return union
    }

    static unionById(arr1, arr2) {
        let union = arr1.concat(arr2)
    
        for (let i = 0; i < union.length; i++) {
            for (let j = i+1; j < union.length; j++) {
                if (union[i]._id === union[j]._id) {
                    union.splice(j, 1)
                    j--
                }
            }
        }
        return union
    }

    // todo: serve this from config settings...

    static templateTransactionKey () {
        return '-Kv4G-2oujQGP7DUvT4T'
    }

    static getKey () {
        return firebase.database().ref().push().key
    }

    static initialiseTenant(tenantKey, onlyIfEmpty) {
        if(onlyIfEmpty) {
            if(!Store.getters.tenantKey) {
                console.log('initialiseTenant > First time set to ' + tenantKey)
                Store.commit('setTenant', {key: tenantKey})
            } else
                //console.log('initialiseTenant > Skipping as key is already ' + tenantKey)
            return
        }
        
        if(tenantKey != Store.getters.tenantKey) {
            console.log('initialiseTenant > Switching tenant from ' + Store.getters.tenantKey + ' to ' + tenantKey)
            Store.commit('setTenant', {key: tenantKey})
        }
    }

    static saveActivity (activity) {

        //let activity = JSON.parse(JSON.stringify(activityToSave))
        
        let key = activity['.key']
        if(!key)
            key = this.getTenantRef().push().key

        delete activity['.key']
        
        activity.stamp = this.getStamp()
        
        if(!activity.sortKey)
            activity.sortKey = StringHelpers.sortKey()
        
        console.log('DataHelpers > saveActivity', activity)
        let ref = this.getTenantRef().child('transactions').child(activity.transactionKey).child('activities').child(key)
        ref.update(activity)
    }

    static saveTransaction (transaction) {
        console.log('DataHelpers > saveTransaction', transaction)
        let transactionKey = transaction['.key']
        if(!transactionKey)
            transactionKey = this.getTenantRef().push().key

        let tran = FirebaseHelpers.cloneWithoutKey(transaction)
        
        tran.stamp = this.getStamp()
        
        let ref = this.getTenantRef().child('transactions').child(transactionKey).child('details')
        
        ref.update(tran)


        // Update for templateTransactions
        //todo: this is inefficient
        let templateRef = this.getTenantRef().child('transactionTemplates').child(transactionKey)
        let templateObj = tran.isTemplate ? tran : {}
        templateRef.set(templateObj)

        //Update for all people associated

        let peopleRef = this.getTenantRef().child('transactions').child(transactionKey).child('people')
        peopleRef.once('value', (peopleSnap) => {
            peopleSnap.forEach( (itemSnap) => {
                let contactKey = itemSnap.key
                let ref = this.getTenantRef().child('contactTransactions').child(contactKey).child(transactionKey)
                ref.update({description: transaction.description})

            })
        })
    }

    static checkFilter(importItem, fields) {
        let match = true
        let result = 'DataHelpers > checkFilter (' + importItem.title + ')'

        if(importItem.filterParameters) {
            for (var parameter in importItem.filterParameters) {
                let field
                if(fields && fields.length)
                    field = fields.find(o => o.parameter == parameter)
                else
                    match = false

                if (match && importItem.filterParameters[parameter] == 'include') {
                    if(!field || !field.answer == true)
                        match = false
                        
                }
                if (match && importItem.filterParameters[parameter] == 'exclude') {
                    if(field && field.answer == true)
                        match = false
                        
                }            
            }  
        } 

        if(importItem.filterSuppliers) {
            
            let transactionSupplierObject = fields.find(o => o.parameter == 'Supplier')
            if(!transactionSupplierObject) {
                console.log('No supplier to filter on')
                match = false
            } else {

                let transactionSupplier = transactionSupplierObject.answer
                
                console.log('Filtering supplier', transactionSupplier)
                
                
                if( (importItem.filterSuppliers[transactionSupplier] != 'include')) {
                    match = false
                }
                if (importItem.filterSuppliers[transactionSupplier] == 'exclude') {
                    match = false
                }            
                 
            }
        }  

        if(match)
            result += ' OK'
        else
            result += ' Reject'

        console.log(result)
        
        return match

    }


    //new: to be tested...

    static checkImport(importItem, fields) {

        // if no filter... let it in!

        if(!importItem.filter)
            return true
        
        // if include filter then need to check it...

        const importInclude = importItem.filter.include
        if(importInclude) {

            //iterate criterias within the filter...

            for (var importParameter in importInclude) {

                //can we find a transaction field with the same name...

                let transactionValue = fields[importParameter]
                if(!transactionValue)
                    return false

                //iterate answers in the filter to see if one matches the transaction field answer...

                let found = false    
                let importValues = importInclude[importParameter]
                for(let importValue in importValues) {
                    if(importValue == transactionValue)
                        found = true
                }
       
                if(!found)
                    return false
            } 
        } 
        return true

    }

}


// WEBPACK FOOTER //
// ./src/helpers/DataHelpers.js